import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const WaveFrontShape = {
  wavefront_url: Yup.string().label("Root URL").url().required(),
  csp_url: Yup.string().label("Page ID").url().optional(),
  csp_app_id: Yup.string().label("CSP OAuth App ID").optional(),
  api_token: Yup.string().label("API Token / OAuth App Secret").required(),
};

export interface WaveFrontInput {
  wavefront_url: string;
  csp_url?: string;
  csp_app_id?: string;
  api_token: string;
}

export const WaveFrontDefaults = {
  csp_url: "https://console.cloud.vmware.com",
};

yupResolver<WaveFrontInput>(Yup.object().shape(WaveFrontShape));
